import { Module } from 'wrapper6'

export default class ProductModal extends Module {
  ready () {
    const productModalButton = document.querySelector('button[data-modal-id="product-contact"]')
    const productModal = document.querySelector('div[data-modal="product-contact"]')

    if (! productModalButton || ! productModal) {
      return
    }

    jQuery(productModalButton).on('click', () => {
      const productTitle = jQuery(productModal)
        .closest('.summary.entry-summary')
        .find('.product_title.entry-title')
        .text()

      jQuery(productModal).find('input[name="product_name"]').val(productTitle)
      jQuery(productModal).find('input[name="product_url"]').val(window.location.href)

      window.openModal(productModal)
    })
  }
}